<template>
    <div class="modify-approve--add-sync">
        <div class="content">
        <vxe-table
            class='atb-table header-table edit-table'
            border='full'
            height='100%'
            auto-resize
            resizable
            :data="taskApproveData"
            ref="taskApproveData"
        >
          <vxe-table-column type='seq' width='50' align='center' title="序号"></vxe-table-column>
          <vxe-table-column field="workClassify" title="工作属性" width="120">
          <template #default="{ row }">{{ workClassifyList.length>0&&workClassifyList.find(t=>t.value==row.workClassify).label || '' }}</template>
          </vxe-table-column>
          <!-- zyq 去掉列表列 -->
          <!-- <vxe-table-column field="workItemCategory" title="类别" width="120"></vxe-table-column> -->
          <vxe-table-column field="workItemContent" title="工作项目" width="120"></vxe-table-column>
          <!-- zyq211221注释 -->
          <!-- <vxe-table-column field="resWkName" title="指定人" width="100"></vxe-table-column> -->
          <vxe-table-column field="weight" title="权重" width="80"></vxe-table-column>
          <vxe-table-column field="fullTarget" title="总目标"></vxe-table-column>
          <vxe-table-column field="finishDate" title="总目标完成日期" width="135">
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <!-- zyq20211221增加发布人，放在最后显示 -->
          <vxe-table-column  title="发布人" width="80">{{sendName}}</vxe-table-column>
          <vxe-table-column field="resWkName" title="指定人" width="80"></vxe-table-column>
        </vxe-table>
        </div>
        <div class="form-wrap" v-if="this.noticeType!='addWork' && hideApprove">
          <el-form :model="editForm" :rules="rules" ref="form" label-width='92px' class="atb-input" label-position="right">  
            <el-form-item label="审批意见" prop="approveReason" label-width="80px">
              <el-input :readonly="!role" type="textarea" maxlength="500" v-model="editForm.approveReason"></el-input>
              <fast-approve v-if="role" @approveText="approveText"></fast-approve>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-wrap">
            <el-button v-if="role&&role!='revert'&&status===10" type="passed" class="btn" @click="passed">通过</el-button>
            <el-button v-if="role&&role!='revert'&&status===10" type="rejected" class="btn" @click="rejected">驳回</el-button>
            <el-button type="clear" class="btn" @click="$parent.$parent.hide()">关闭</el-button>
        </div>
    </div>
</template>
<script>
import editMixin from '@/mixins/edit.mixin'
import XEUtils from 'xe-utils'
import qs from 'qs'
export default {
  mixins: [ editMixin ],
   props: {
    // 编辑信息
    editData: {
      type: Object,
      default: ()=>{}
    },
    msgObjectId:{
      typeof:String,
      default:''
    },
    role:{
      type:Number,
      default:0
    },
    msgId:{
      type:String,
      default:''
    },
    noticeType:{
      type:String,
      default:''
    },
    msgObjectChildId:{
      type:String,
      default:''
    },
    sendName:{
      type:String,
      default:''
    },
    hideApprove: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      that: this,
      id: 'id',
      editForm: {
        approveReason:''
      },
      taskApproveData:[],
      workClassifyList: [
        {label: '重要KPI', value: 0},
        {label: '业务工作', value: 10},
        {label: '费效管理', value: 20},
        {label: '人力资源', value: 30},
        {label: '企业文化', value: 40},
        {label: '个人成长', value: 50},
        {label: '其他新增工作', value: 60},
     ],
     state:0
    }
  },
 computed: {
      workClassifyName(val){
          return this.workClassifyList.length>0&&this.workClassifyList.find(t=>t.value===val).label;
      }
  },
  mounted(){
    this.getList();
  },
  methods:{
    approveText(e) {
      this.editForm.approveReason = e;
    },
    getList() {
      if(this.noticeType==="addWork"){
        this.$ajax.get(this.$api.year.yearWorkDetail.list +'?'+ qs.stringify({WorkId: this.msgObjectId,  WorkItemIds: this.msgObjectChildId},{indices: false})).then((res) => {
          this.taskApproveData=res.data&&res.data.details;
          this.taskApproveData.length&&this.$set(this.editForm,'approveReason',this.taskApproveData[0].approveReason);
          this.taskApproveData.length? this.status=this.taskApproveData[0].status: 0;
        });
      }else{
        this.$ajax.get(this.$api.add.PublishYearWork.list +'?'+ qs.stringify({WorkItemIds: this.msgObjectId},{indices: false})).then((res) => {
          this.taskApproveData=res.data && res.data.rows.details && res.data.rows.details[0] ? res.data.rows.details[0].items : [];
          this.taskApproveData.length&&this.$set(this.editForm,'approveReason',this.role? '': this.taskApproveData[0].approveReason);
          this.taskApproveData.length? this.status=this.taskApproveData[0].status: 0;
        });
      }
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format)
    },
    passed(){
      const params=this.taskApproveData[0]||{};
      params.status=20;
      params.approveReason=this.editForm.approveReason;
      params.msgId=this.msgId;
      this.$ajax.put(this.$api.add.PublishYearWork.updateStatus, params).then(res=>{
          if(res.code===0){
              this.$refs.form.resetFields();
              this.$message.success('保存成功');
              this.$emit('submitSuccess');
              this.editForm={};
              this.$parent.$parent.hide();
          }
        });
    },
    rejected(){
      const params=this.taskApproveData[0]||{};
      params.status=30;
      params.approveReason=this.editForm.approveReason;
      params.msgId=this.msgId;
      if(typeof(params.approveReason)==="undefined" || params.approveReason===null || params.approveReason.split(" ").join("").length === 0 || params.approveReason.replace(/\s+/g,"").length===0){
        return  this.$message.error("必须填写驳回原因");
      }
      this.$ajax.put(this.$api.add.PublishYearWork.updateStatus, params).then(res=>{
        if(res.code===0){
            this.$refs.form.resetFields();
            this.$message.success('保存成功');
            this.$emit('submitSuccess');
            this.editForm={};
            this.$parent.$parent.hide();
        }
      });
    },
  },
 watch: {
    }
}
</script>
<style scoped lang='scss'>
  .modify-approve--add-sync {
    .content{
        height: 260px;
    }
    .el-button.el-button--passed {
        color: #ffffff;
        background-color: #22b6a1;
        border-color: #22b6a1;
    }
    .el-button.el-button--rejected {
        background-color: #0dcc82;
        border-color: #0dcc82;
        color: #ffffff;
    }
    .el-button.el-button--clear {
        background-color: #F5BF2B;
        border-color: #F5BF2B;
        color: #ffffff;
    }
    .el-button {
        width: 110px;
        border-radius: 10px;
    }
    .btn-wrap{
         text-align: right;
         margin-top: 10px;
    }
    .form-wrap{
        margin: 10px 0px;
        .el-autocomplete{
            width: 100%;
        }
        .customerSelect{
            width: 100%;
        }
    }
    ::v-deep .header-table {
      table{
        height: 100%;
      }
      overflow: auto;
      flex-grow: 1;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
      .main-row {
        .vxe-body--column {
          padding: 0;
        }
        .vxe-cell {
          padding: 0;
        }
      }
    }
    .kpi-add {
      height: 48px;
      background-color: $--color-bg-table-header;
      color: $--color-primary;
      font-size: 14px;
      margin-top: -1px;
      padding: 0 15px;
      span {
        cursor: pointer;
      }
    }
    .atb-input {
      .el-form-item{
        margin-right: 0px;
      }
    }
  }
</style>